var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMyAccount35X37 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 35 37"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.346 21.153c.152-.022 1.262 1.039 1.504 1.217a14.47 14.47 0 0 0 15.73.986c1.088-.614 2.018-1.436 2.994-2.204 3.439 2.316 6.358 6.224 7.298 10.306.575 2.499-.837 4.331-3.34 4.62l-27.69.005C.516 35.886-.617 33.568.314 30.53c1.157-3.775 3.805-7.16 7.035-9.38z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.43 0c8.631-.03 13.82 9.681 8.997 16.858-4.36 6.487-14.13 6.294-18.173-.402C3.921 9.277 9.038.028 17.43 0"
})));
export default SvgMyAccount35X37;